__webpack_require__.p = "https://scitforte.com/";